module.exports = __webpack_public_path__ + "img/img_cx4_open.0d05241a.jpg";